import { MESSAGES } from 'shared/config/validations';
import * as yup from 'yup';
export const accountPlatformFromSchema = yup.object({
  name: yup.string().required(MESSAGES.REQUIRED_FIELD),
});
